module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "tc-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tc-box-model-top"
  }, [_c('div', {
    staticClass: "tc-box-model-top-div"
  }), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-top-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tishi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/wode_jiazu@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-center"
  }, [_vm._v(_vm._s(_vm.$t('all.shifouquedingjieshuzhibo')))]), _vm._v(" "), _c('div', {
    staticClass: "tc-box-model-bottom",
    on: {
      "click": _vm.closeChatRoom
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0cd58f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guanbizhibo/guanbizhibo.vue
// module id = 1012
// module chunks = 1